// Converts snake_case keys to camelCase recursively
function toCamelCase(str) {
  return str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
}

function keysToCamelCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map(keysToCamelCase);
  }

  if (obj !== null && obj !== undefined && obj.constructor === Object) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      acc[toCamelCase(key)] = keysToCamelCase(value);
      return acc;
    }, {});
  }

  return obj;
}

export default keysToCamelCase;
